import React, { useState, useEffect } from 'react'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../../authConfig'
import Button from 'react-bootstrap/Button'
import { api } from '../shared/ApiProvider'

export default function ProfileContent() {
  const { instance, accounts, inProgress } = useMsal()
  const [accessToken, setAccessToken] = useState(null)
  const name = accounts[0] && accounts[0].name

  useEffect(() => {
    // Prevent silent authentication if appLoggedOut flag is set
    if (localStorage.getItem('appLoggedOut') === 'true') {
      setAccessToken(null)
      return
    }
    RequestAccessToken()
  }, [accessToken])

  function RequestAccessToken() {
    localStorage.removeItem('appLoggedOut') // Clear appLoggedOut flag on manual authenticate
    const request = {
      ...loginRequest,
      account: accounts[0],
    }

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        setAccessToken(response.idToken)
        localStorage.setItem('msalIdToken', response.idToken)
        api.defaults.headers['Authorization'] = `Bearer ${response.idToken}`
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          setAccessToken(response.accessToken)
        })
      })
  }

  return (
    <>
      {accessToken ? (
        <p style={{ color: 'green' }} className="text-center">
          Authenticated
        </p>
      ) : (
        <div className="justify-content-center text-center alert-warning">
          <Button
            variant="alert-warning"
            className="justify-content-centertext-center alert-warning"
            style={{ textDecoration: 'none' }}
            onClick={RequestAccessToken}
          >
            Authenticate
          </Button>
        </div>
      )}
    </>
  )
}
